import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import { MODES_OPTIONS } from "../../../types/generics.types";
import CalibrationListLayout from "../../calibrations/components/layouts/layout";
import CalibrationList from "../../calibrations/calibrations";
import CalibrationEditLayout from "../../calibrations/components/layouts/layoutEdit";
import EditCalibration from "../../calibrations/editCalibrations";
import CalibrationEfficiencyForm from "../components/efficiencies/efficiencyForm";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesCalibration: RouteObject = {
  path: pathRoutes.ADMIN_CALIBRACIONES,
  element: <CalibrationListLayout />,
  children: [
    {
      index: true,
      element: (
        <Authenticated>
          <CalibrationList />
        </Authenticated>
      ),
    },
    {
      path: "nuevo",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <CalibrationEditLayout />
        </PrivateRoutes>
      ),
      children: [
        {
          path: "eficiencia",
          element: (
            <Authenticated>
              <CalibrationEfficiencyForm mode={MODES_OPTIONS.NEW} />
            </Authenticated>
          ),
        },
        {
          path: "analisis",
          element: (
            <Authenticated>
              <EditCalibration mode={MODES_OPTIONS.NEW} />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "editar",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <CalibrationEditLayout />
        </PrivateRoutes>
      ),
      children: [
        {
          path: "eficiencia/:idCalibration",
          element: (
            <Authenticated>
              <CalibrationEfficiencyForm mode={MODES_OPTIONS.EDIT} />
            </Authenticated>
          ),
        },
        {
          path: "analisis/:idCalibration",
          element: (
            <Authenticated>
              <EditCalibration mode={MODES_OPTIONS.EDIT} />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "ver",
      element: <CalibrationEditLayout />,
      children: [
        {
          path: "eficiencia/:idCalibration",
          element: (
            <Authenticated>
              <CalibrationEfficiencyForm mode={MODES_OPTIONS.VIEW} />
            </Authenticated>
          ),
        },
        {
          path: "analisis/:idCalibration",
          element: (
            <Authenticated>
              <EditCalibration mode={MODES_OPTIONS.VIEW} />
            </Authenticated>
          ),
        },
      ],
    },
  ],
};

export default routesCalibration;
